// extracted by mini-css-extract-plugin
export default {"heading":"MySkills_heading__W9-yz","container":"MySkills_container__cVMev","card":"MySkills_card__Ya27d","stack":"MySkills_stack__vxCUE","title":"MySkills_title__ktBwI"};